/* tslint:disable */
/* eslint-disable */
/**
 * axfoodstorefront API
 * axfoodstorefront Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PriceData
 */
export interface PriceData {
    /**
     * 
     * @type {string}
     * @memberof PriceData
     */
    'currencyIso'?: string;
    /**
     * 
     * @type {string}
     * @memberof PriceData
     */
    'formattedValue'?: string;
    /**
     * 
     * @type {number}
     * @memberof PriceData
     */
    'maxQuantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceData
     */
    'minQuantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof PriceData
     */
    'priceType'?: PriceDataPriceTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PriceData
     */
    'value'?: number;
}

export const PriceDataPriceTypeEnum = {
    Buy: 'BUY',
    From: 'FROM'
} as const;

export type PriceDataPriceTypeEnum = typeof PriceDataPriceTypeEnum[keyof typeof PriceDataPriceTypeEnum];


